module.exports = "/assets/9c27d99a012c2d491c04d127b6d2deb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CQ.png
// module id = 1274
// module chunks = 0